import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";
import { getCategoryStyle } from "@/utils/format";

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <SectionHeading
        eyebrow="圈层分类"
        title="你想吃的瓜，都分好类了"
        desc="六个常驻瓜田，按圈层归档、按热度排序，不用在信息流里翻找。"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat, index) => {
          const style = getCategoryStyle(cat.slug);
          const count = articles.filter((item) => item.category === cat.slug).length;
          const featured = index === 0;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group flex flex-col rounded-lg border p-5 md:p-6 transition-colors cursor-pointer ${
                featured
                  ? "bg-accent-100 border-accent-200 hover:border-accent-300"
                  : "bg-background-100 border-background-200 hover:border-primary-200"
              }`}
            >
              <div className="flex items-center justify-between mb-4">
                <span
                  className={`w-11 h-11 rounded-md flex items-center justify-center ${style.chip}`}
                >
                  <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-500 bg-background-50 border border-background-200 px-2 py-1 rounded-full">
                  {count} 条在更
                </span>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed flex-1">
                {cat.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 whitespace-nowrap">
                进入瓜田
                <i
                  className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"
                  aria-hidden="true"
                ></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}